import React from 'react';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Modal from '../components/Modal';
import BasePage from './BasePage';
import AccedanApi from '../api/AccedanApi';
import $ from 'jquery';

class RecoverPassword extends BasePage {

    loadOnConstructor(){
        this.recoverForm = this.recoverForm.bind(this);
        this.recoverCallBack = this.recoverCallBack.bind(this);
        this.goLogin = this.goLogin.bind(this);

        this.state = {};
        this.getCommonInterface(this.getCommonInterfaceCallback);
    }

    goLogin(e){
	e.preventDefault();
	this.navigateTo('/login');
    }

    render() {
        return (
            <>
<div className="wrapper fadeInDown">
  <div id="formContent">

    <div className="fadeIn first">
    </div>

    <div id="formFooter">
	<label>{this.getTrad('introduceYourUserEmail')}</label>
    </div>

    <form onSubmit={this.recoverForm} className="mt-4">
      <input type="text"
          name="email" 
          placeholder="ejemplo@email.com" 
          ref={(c) => this.email = c} 
          id="email" 
      	  className="fadeIn second login" />
      <input type="submit" className="fadeIn fourth mt-4 login mb-1" value="Enviar" />
      <input type="submit" className="fadeIn fourth login" value="Volver" onClick={this.goLogin} />
    </form>

  </div>
</div>
                <Modal />
            </>
        )
    }

    recoverForm(e){
        e.preventDefault();

        if(!this.email.value){
		this.props.setModalContent({
			title: this.getTrad('validationError'),
			body: [this.getTrad('introduceCorrectEmail')],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});
		$("#exampleModal").modal('toggle');
		return;
	}

        const api = new AccedanApi();
        const arrayParams = [
            {name: "email", value: this.email.value}
        ];
        api.recoverPassword(arrayParams, this.recoverCallBack);
    }

    recoverCallBack(response){

        if(response.status === 'OK'){
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('messageSentToEmail'),
				this.getTrad('checkYourEmail')],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true, callback: this.goBack }
			]
		});
		$("#exampleModal").modal('toggle');
        }else if(response.status === 'KO'){
			this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			body: [this.getTrad('emailNotRegistered'),
				this.getTrad('checkYourDataAndTryAgain')],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});
		$("#exampleModal").modal('toggle');
	
	}
    }
}

const mapStateToProps = state => {
    return {
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(RecoverPassword)
